/** Which columns the client table shows. Hidden ones still export. */
import { FIELDS, headingOf } from '../../constants/defaults.js';
import { useApp } from '../../store/AppContext.jsx';
import { Section, CheckGrid } from './SettingsBits.jsx';

export default function ColumnsPane() {
  const { S, patchSettings, toast } = useApp();
  const hidden = new Set(S.hidden || []);

  const toggle = (key, show) => {
    const next = new Set(hidden);
    if (show) next.delete(key); else next.add(key);
    if (!FIELDS.filter(f => !next.has(f.k)).length) {
      toast('Keep at least one column');
      return;
    }
    patchSettings({ hidden: [...next] });
  };

  return (
    <Section title="Visible columns" hint="Hidden columns stay in your data and still export.">
      <CheckGrid>
        {FIELDS.map(f => (
          <label key={f.k}>
            <input
              type="checkbox"
              checked={!hidden.has(f.k)}
              onChange={e => toggle(f.k, e.target.checked)}
            />
            {headingOf(f, S)}
          </label>
        ))}
      </CheckGrid>
    </Section>
  );
}
